var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlignleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11098 2.21684H9.18765C9.2593 2.21684 9.31792 2.15408 9.31792 2.07739V1.10124C9.31792 1.02454 9.2593 0.961792 9.18765 0.961792H1.11098C1.03933 0.961792 0.980713 1.02454 0.980713 1.10124V2.07739C0.980713 2.15408 1.03933 2.21684 1.11098 2.21684ZM1.11098 9.60765H9.18765C9.2593 9.60765 9.31792 9.54489 9.31792 9.4682V8.49205C9.31792 8.41535 9.2593 8.3526 9.18765 8.3526H1.11098C1.03933 8.3526 0.980713 8.41535 0.980713 8.49205V9.4682C0.980713 9.54489 1.03933 9.60765 1.11098 9.60765ZM13.8773 12.048H1.11098C1.03933 12.048 0.980713 12.1108 0.980713 12.1875V13.1636C0.980713 13.2403 1.03933 13.3031 1.11098 13.3031H13.8773C13.949 13.3031 14.0076 13.2403 14.0076 13.1636V12.1875C14.0076 12.1108 13.949 12.048 13.8773 12.048ZM13.8773 4.6572H1.11098C1.03933 4.6572 0.980713 4.71995 0.980713 4.79665V5.77279C0.980713 5.84949 1.03933 5.91224 1.11098 5.91224H13.8773C13.949 5.91224 14.0076 5.84949 14.0076 5.77279V4.79665C14.0076 4.71995 13.949 4.6572 13.8773 4.6572Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignleft);
export default __webpack_public_path__ + "static/media/alignleft.ba7a05ecc1bd8e2c5056ace46fb7b500.svg";
export { ForwardRef as ReactComponent };